export const focusablesSelector = 'button, [href], input, select, textarea, [role="menuitem"], [tabindex]:not([tabindex="-1"])';

export const findFocusableChildren = (element) => element.querySelectorAll(focusablesSelector);
export const findFocusableChild = (element) => element.querySelector(focusablesSelector);

export const focusFocusableChild = (element) => {
  const focusable = findFocusableChild(element);
  focusable.focus();
  (focusable || element).focus();
};

export const hasModifierKey = (event) => event instanceof KeyboardEvent &&
  (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);

export const handleTrapFocus = (elements) => (event) => {
  event.preventDefault();
  // if the focused element is within modal, focus it
  if (elements?.focusableEls.includes(event?.target)) {
    elements.currentFocus = event.target;
  } else {
    // new focus not part of the collected focusable elements in modal,
    // we are probably out of the modal, so if the last valid focus is first focusbale element,
    // jump to the last focusable element [creating a vertical wrapped effect]
    if (elements.currentFocus === elements.firstFocusableEl) {
      elements.lastFocusableEl?.focus();
    } else {
      // if the last valid focus is last focusbale element, jump to the first focusable element
      elements.firstFocusableEl?.focus();
    }
    // update the currently focused element
    elements.currentFocus = document.activeElement;
  }
};

/**
 * @param {*} element modal container
 * @param {*} lastBgFocusedElement last focused element [before modal launch]
 * @returns FUNCTION - to untrap focus
 */
export const trapFocus = (element, lastBgFocusedElement) => {
  const focusableEls = Array.from(findFocusableChildren(element));
  const elements = {
    focusableEls,
    firstFocusableEl: focusableEls[0],
    lastFocusableEl: focusableEls[focusableEls.length - 1],
    currentFocus: null,
  };

  elements.firstFocusableEl?.focus();
  elements.currentFocus = elements.firstFocusableEl;

  const handleFocus = handleTrapFocus(elements);

  document.addEventListener('focus', handleFocus, true);

  return {
    untrap: () => {
      // remove focus event listener
      document.removeEventListener('focus', handleFocus, true);
      // manually return focus to the last focused element before modal launch
      lastBgFocusedElement?.focus();
    },
  };
};
